// extracted by mini-css-extract-plugin
export default {"root":"Layout--root--1bfdi","content":"Layout--content--3GH5z"};